var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-habilitado"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"width":"300px"},attrs:{"src":"public/images/site/no-finished.svg","alt":"Error"}}),_vm._v(" "),_c('h1',[_vm._v("Ocurrió un error")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.errorMensaje))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4990903d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Error.vue
// module id = 520
// module chunks = 0